import { Link } from 'react-router-dom';
import { Code2, Mail, MapPin, Github, Linkedin } from 'lucide-react';
import NewsletterSignup from '../NewsletterSignup';

export default function Footer() {
  return (
    <footer className="border-t bg-muted/50" role="contentinfo">
      <div className="container mx-auto px-4 py-12">
        {/* Item 16: Bento-style grid with card backgrounds */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="rounded-xl bg-background/60 border border-border/50 p-6 space-y-4 md:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2" aria-label="Innovation Coders - Home">
              <Code2 className="h-6 w-6 text-primary" aria-hidden="true" />
              <span className="text-lg font-bold">Innovation Coders</span>
            </Link>
            <p className="text-sm text-muted-foreground">
              Transforming ideas into powerful digital solutions. Custom software development, SaaS products, and digital innovation.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://github.com/innovationcoders"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-9 w-9 items-center justify-center rounded-full border bg-background text-muted-foreground hover:border-primary hover:text-primary transition-colors"
                aria-label="GitHub"
              >
                <Github className="h-4 w-4" aria-hidden="true" />
              </a>
              <a
                href="https://www.linkedin.com/company/innovationcoders"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-9 w-9 items-center justify-center rounded-full border bg-background text-muted-foreground hover:border-primary hover:text-primary transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-4 w-4" aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="rounded-xl bg-background/60 border border-border/50 p-6">
            <h3 className="mb-4 text-sm font-semibold">Services</h3>
            <ul className="space-y-2.5 text-sm text-muted-foreground">
              <li><Link to="/services" className="hover:text-primary transition-colors">Custom Development</Link></li>
              <li><Link to="/services" className="hover:text-primary transition-colors">SaaS Solutions</Link></li>
              <li><Link to="/services" className="hover:text-primary transition-colors">Mobile Apps</Link></li>
              <li><Link to="/services" className="hover:text-primary transition-colors">Cloud Infrastructure</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="rounded-xl bg-background/60 border border-border/50 p-6">
            <h3 className="mb-4 text-sm font-semibold">Company</h3>
            <ul className="space-y-2.5 text-sm text-muted-foreground">
              <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/portfolio" className="hover:text-primary transition-colors">Portfolio</Link></li>
              <li><Link to="/case-studies" className="hover:text-primary transition-colors">Case Studies</Link></li>
              <li><Link to="/pricing" className="hover:text-primary transition-colors">Pricing</Link></li>
              <li><Link to="/estimator" className="hover:text-primary transition-colors">Project Estimator</Link></li>
              <li><Link to="/blog" className="hover:text-primary transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
              <li><Link to="/testimonials" className="hover:text-primary transition-colors">Testimonials</Link></li>
              <li><Link to="/careers" className="hover:text-primary transition-colors">Careers</Link></li>
              <li><Link to="/faq" className="hover:text-primary transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="rounded-xl bg-background/60 border border-border/50 p-6">
            <h3 className="mb-4 text-sm font-semibold">Contact</h3>
            <ul className="space-y-2.5 text-sm text-muted-foreground">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
                <a href="mailto:hello@innovationcoders.com" className="hover:text-primary transition-colors">
                  hello@innovationcoders.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
                <span>Calgary, Alberta, Canada</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Newsletter signup */}
        <div className="mt-8 rounded-xl bg-background/60 border border-border/50 p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <h3 className="text-sm font-semibold">Stay in the loop</h3>
              <p className="mt-1 text-sm text-muted-foreground">
                Get the latest insights on software development and digital innovation.
              </p>
            </div>
            <NewsletterSignup variant="inline" source="footer" />
          </div>
        </div>

        <div className="mt-8 border-t pt-8 text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Innovation Coders. All rights reserved.</p>
          <div className="mt-2 flex items-center justify-center gap-4">
            <Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <span>·</span>
            <Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link>
            <span>·</span>
            <span>Built with ❤️ in Calgary</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
